<template>
    <div class="spell-wrap">
        <!--遮罩层-->
        <div class="left-title">
            <div>
                <img src="@/assets/img/grammarTest/book.png" alt="">
                <p><b>智能精准复习中</b></p>
            </div>
        </div>
        <div class="content-box">
            <transition name="el-fade-in-linear" mode="out-in">
                <div class="hint-text" v-if="isHint" key="save">
                    <div class="hint-box">
                        <div class="hint-title">复习定位：本次学习 <span class="green">拼写</span><span class="orange">错误</span>的单词</div>
                        <div class="hint-tips">[ 提示：您在本次学习过程中正确率仅达到<span>{{robotData.rate}}%</span> ]</div>
                    </div>
                    <div style="margin-top:30px;">
                        <el-button type="success" @click="selectOrder(1)">开始复习</el-button>
                    </div>
                </div>
                <!--练习框-->
                <div class="exercise-box spell-box" v-if="showExercise" key="1">
                    <div class="translate">
                        <el-button v-if="!showTranslate" style="background:#2BC3B9;color: #fff "
                                    @click="showTranslate=!showTranslate">
                            词义提示
                        </el-button>
                        <el-button type="danger" v-else @click="showTranslate=!showTranslate" plain>
                            词义隐藏
                        </el-button>
                        <transition name="el-zoom-in-left">
                            <div v-if="showTranslate" class="translate-text">
                                {{spellData.word.meaning?spellData.word.meaning:'没有提示哦'}}
                            </div>
                        </transition>
                    </div>
                    <div class="input-box popup-box">
                        <!--输入框左侧语音按钮-->
                        <div class="audio-btn">
                            <img src="../../../../assets/img/grammarTest/headset.png"
                                    @click="playAudio" alt="">
                        </div>
                        <audio id="eventAudio" :src="spellData.word.voice" autoplay></audio>
                        <!--填写答案输入框-->
                        <el-input v-model="wordInput" placeholder="" @keyup.enter.native="getNextWord()"
                                    @input="checkout">
                        </el-input>
                        <div class="input-btn">
                            <el-button v-if="isNext"
                                        type="success"
                                        @click="getNextWord()">
                                下一个
                            </el-button>
                            <div class="input-hint-img">
                                <!--错误的情况-->
                                <img class="animated flipInX"
                                        v-if="isError"
                                        src="@/assets/img/grammarTest/error.png" alt="">
                                <!--正确的情况-->
                                <img class="animated flipInX"
                                        v-if="isCorrect"
                                        src="@/assets/img/grammarTest/correct.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!--                        显示答案-->
                    <transition name="el-fade-in" mode="out-in">
                        <div class="error" v-if="showHint||spellData.is_force==1">
                            {{spellData.word.name}}
                        </div>
                    </transition>
                </div>
            </transition>
        </div>
        <div class="el-message-box__btns" key="edit">
            复习时间【{{timeNum || '00:00:00'}}】已复习【{{saveInfo.study_num||0}}】单词数【{{dataSource.count||0}}】
        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import {wordRobotGet, wordRobotSave, wordRobotQuit, selectUnit} from "@/api/words";

    export default {
        name: "aiPreciseSpell",
        props: {
            dataSource: {},
        },
        computed: {
            ...mapGetters(['wordStudyStage', 'robotData', 'showRobot'])
        },
        data() {
            return {
                spellCount: '',//单词总量
                saveInfo: {
                    num: '1',//学习总次数（默认1）
                    state: '1',//类型（默认1）
                    study_num: 0,
                },
                grammarIcon: require('../../../../assets/img/grammarTest/one.png'),//填空题图标
                spellInput: '',//单词输入框
                isHint: true,//是否显示强制复习提示语
                showExercise: false,//是否显示练习框
                showHint: false,//是否显示答案
                isError: false,//是否拼写错误
                isCorrect: false,//是否拼写正确
                showTranslate: false,//是否显示词义提示
                isNext: true,//控制'下一个'按钮的显示
                showResult: false,//显示结果|
                spellData: {},//拼写学习数据
                timeVal: {
                    hour: 0,
                    minutes: 0,
                    seconds: 0
                },
                timeNum: '',//记忆时间
                secondNum: 0,//只记录秒格式
                clock: '',//倒计时
                totalTime: '20',//倒计时初始时间
                studyTime: 1,//间隔时间
                studyEnd: true,//停止学习
                wordInput: '',//拼写输入框
                studyStatus: '',//当前组是否学习完的状态
            };
        },
        methods: {
            ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
            //触发发音
            playAudio() {
                let buttonAudio = document.getElementById('eventAudio');
                buttonAudio && buttonAudio.play()
            },
            //开始拼写
            selectOrder() {
                this.isHint = false;
                this.showExercise = true
                this.spellCount = this.dataSource.count
                //记录间隔时间
                this.recordIntervalTime()
                this.getSpellData()
                //开始计时
                this.timeKeep()
            },
            //获取单词
            getSpellData() {
                let params = {
                    token: Lockr.get('token'),
                    student_id: this.dataSource.student_id,//学员Id
                    count: this.spellCount,
                    num: this.saveInfo.num,
                    state: this.saveInfo.state || 1,
                }
                wordRobotGet(params).then((res) => {
                    this.spellData = res.data
                    // 测试专用 start
                    this.debugFn(()=>{
                        this.wordInput = res.data.word.name
                    })
                    // 测试专用 end
                    this.countDown(this.spellData.word.time)
                    // this.countDown(20)
                    this.playAudio()
                })
            },
            //下一个
            getNextWord() {
                this.clock && window.clearInterval(this.clock)
                this.isReadonly = false
                // this.showTranslate = false
                if (this.spellData.word.name == this.wordInput) {
                    // 拼写正确的情况
                    this.isNext = false
                    this.isCorrect = true
                    this.studyEnd = true
                    setTimeout(() => {
                        this.isCorrect = false
                        this.isNext = true
                        this.pushSpell(1)
                    }, 1500)
                } else if (this.spellData.is_force == 1) {
                    this.isNext = false
                    this.showHint = true
                    this.isError = true
                    setTimeout(() => {
                        this.isNext = true
                        this.isError = false
                        this.showHint = false
                    }, 2000)
                } else {
                    // 拼写错误的情况
                    this.isNext = false
                    this.isError = true
                    this.showHint = true
                    setTimeout(() => {
                        this.isNext = true
                        this.isError = false
                        this.showHint = false
                        this.pushSpell(0)
                    }, 2000)
                }
            },
            //点击下一个时提交拼写
            pushSpell(isPass) {
                this.wordInput = ''
                if (this.studyEnd) {
                    if (this.spellData.is_force == 1 && isPass == 0) {
                        //如果本单词要求强制拼写，那么必须输入正确才能提交
                        return
                    }
                    let params = {
                        token: Lockr.get('token'),
                        student_id: this.dataSource.student_id,//学员Id
                        num: this.saveInfo.num,
                        state: this.spellData.state,
                        word_id: this.spellData.word.word_id,
                        count: this.spellCount,
                        study_time: this.studyTime,
                        is_pass: isPass,
                        unit_id: this.dataSource.unit_id,
                        cur_group: this.dataSource.cur_group,
                    }
                    wordRobotSave(params).then(res => {
                        // 判断智能精准复习是否完成，完成继续学习下一组
                        if (res.data.is_complete == 1 || res.data.is_complete == 2) {
                            this.studyStatus = res.data.is_complete
                            this.saveStudyState()
                        } else {
                            //获取下一个单词
                            this.saveInfo.num = this.saveInfo.num * 1 + 1
                            this.saveInfo.study_num = res.data.study_num
                            this.getSpellData()
                            this.recordIntervalTime('reset')
                        }
                    })
                }
            },
            //保存当前组学习状态
            saveStudyState() {
                let params = {
                    token: Lockr.get('token')
                }
                wordRobotQuit(params).then(res => {
                    if (res.code == 1) {
                        this.$store.commit('UPDATE_ROBOT_DATA', {})
                        this.$store.commit('CHANGE_ROBOT_SHRINK', true)
                        this.$store.commit('CHANGE_ROBOT', false)
                        this.$store.commit('CHANGE_AI_PRECISE', false)
                        this.nextGroup()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                })
            },
            // 继续下一组单词学习
            nextGroup () {
                let params = {
                    token: Lockr.get('token'),
                    unit_id: Lockr.get('unit_id'),
                }
                selectUnit(params).then(res => {
                    Lockr.rm('unit_id')
                    if (res.code == 1) {
                        let data = {
                            type: 'wordStudy/wordIdentify',
                            dataSource: res.data
                        }
                        data.dataSource.markedWords = '即将进入下一组，go go go!'
                        data.dataSource.studyStatus = this.studyStatus
                        this.CHANGE_WORD_STUDY_TYPE(data)
                    }
                })
            },
            // 记录间隔时间
            recordIntervalTime(reset) {
                let timer = setInterval(() => {
                    this.studyTime += 1
                }, 1000)
                if (reset == 'reset') {
                    window.clearInterval(timer)
                    this.studyTime = 0
                }
            },

            //开启记忆时间
            timeKeep() {
                setInterval(this.startTimer, 1000);
            },
            //记忆时间记录器
            startTimer() {
                this.timeVal.seconds += 1;
                this.secondNum += 1
                if (this.timeVal.seconds >= 60) {
                    this.timeVal.seconds = 0;
                    this.timeVal.minutes = this.timeVal.minutes + 1;
                }
                if (this.timeVal.minutes >= 60) {
                    this.timeVal.minutes = 0;
                    this.timeVal.hour = this.timeVal.hour + 1;
                }
                //记忆总时间
                this.timeNum = (this.timeVal.minutes < 10 ? '0' + this.timeVal.minutes : this.timeVal.minutes) + ':' + (this.timeVal.seconds < 10 ? '0' + this.timeVal.seconds : this.timeVal.seconds);
            },
            //倒计时
            countDown(endTime = 20, stop) {
                //每切换一题倒计时重置一遍
                window.clearInterval(this.clock)
                if (stop || this.spellData.is_force == 1) return //查看答案时 计时器不执行
                this.totalTime = endTime
                // this.totalTime = 30
                this.clock = window.setInterval(() => {
                    this.totalTime--
                    this.content = this.totalTime
                    if (this.totalTime <= 0) {
                        window.clearInterval(this.clock)
                        this.getNextWord()
                        this.recordIntervalTime('reset')
                        this.totalTime = endTime
                    }
                }, 1000)
            },
            checkout() {
                if (this.spellData.is_force == 1) {
                    let answerInput = this.wordInput // aa
                    let answerLen = answerInput.length // 2
                    let answer = this.spellData.word.name // aab
                    let str = answer.substring(0, answerLen)
                    if (str !== answerInput) {
                        let res = this.getAnswerSuccessLength(answer, answerInput)
                        this.wordInput = res.join('')
                    }
                }
            },
            getAnswerSuccessLength (answer, str) {
                let arr_answer = answer.split('')
                let arr_str = str.split('')
                let len = arr_answer.length > arr_str.length ? arr_str.length : arr_answer.length
                let res = []
                for (let i = 0; i < len; i++) {
                    if (arr_answer[i] === arr_str[i]) {
                        res.push(arr_answer[i])
                    }
                    if ((arr_answer[i] == ' ' || arr_answer[i] == ' ')  && arr_str[i] == ' ') {
                        res.push(' ')
                    }
                }
                return res
            }
        }
    }
</script>

<style lang='less' scoped>
.spell-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;

    .left-title {
        padding: 20px 0 0 20px;
        height: 50px;
        color: #333;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
            }

            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }

        .countDown {
            background: url('../../../../assets/img/grammarTest/time_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 50px;
            height: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .content-box {
        transition: all .5s;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .hint-text {
            flex: 1;
            position: relative;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            > .hint-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 600px;
                height: 160px;
                box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
            }
            .hint-title{
                color: #333;
                font-size: 24px;
                font-weight: bold;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                span{
                    font-size: 28px;
                    padding: 0 6px;
                }
                span.green{
                    color: #1cac7a;
                }
                span.orange{
                    color: #fd6721;
                }
            }

            .hint-tips {
                color: #666;
                margin: 5px 0;
                font-size: 14px;
                span{
                    font-size: 16px;
                    color: #cf5c4b;
                    text-decoration: underline;
                    font-weight: bold;
                    padding: 0 6px;
                }
            }
        }

        .exercise-box {
            padding: 40px 20px 20px 50px;
            flex: 1;
            display: flex;
            flex-direction: column;

            .statement-text {
                font-size: 30px;
                font-weight: 600;
                display: flex;
                align-items: center;
                margin: 20px 0;
                padding-right: 40px;

                > .volume {
                    margin-left: 5px;
                    cursor: pointer;
                    height: 33px;

                    img {
                        width: 35px;
                    }

                    img:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }


    /*单词相关*/
    .spell-box {
        .translate {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .translate-text {
                font-size: 21px;
                font-weight: 600;
                margin-left: 30px;
                width: 600px;
            }
        }

        .input-box {
            display: flex;
            align-items: center;
            margin: 12px 0;

            .input-btn {
                margin: 0 20px;
                cursor: pointer;
                transition: all .5s;
                width: 50px;

                .input-hint-img {
                    img {
                        width: 50px;
                        height: 50px;
                    }
                }
            }

            .audio-btn {
                margin-right: 20px;
                cursor: pointer;
                transition: all .5s;
                width: 50px;
                img {
                    width: 50px;
                    height: 50px;
                }
            }

            .audio-btn:hover {
                opacity: .7;
            }
        }

        .issue {
            font-size: 36px;
            color: #FF6600;
            margin: 20px 0;
            min-height: 50px;

            /deep/ span {
                display: inline-block;
                width: 50px;
                height: 35px;
                margin: 0 5px;
                border-bottom: 1px dashed #979797;

                /deep/ img {
                    display: block;
                    width: 28px;
                    height: 28px;
                    margin: 0 auto;
                }
            }
        }

        .error {
            padding-left: 80px;
            color: #E50114;
            margin-top: 10px;
            font-size: 30px;
            font-weight: 600;
        }
    }

    .result-box {
        display: flex;
        width: 100%;

        .left-box, .right-box {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 18px;
            font-weight: 600;

            .test-info {
                display: flex;
                align-items: center;
                margin: 10px 0;
                justify-content: center;

                img {
                    width: 30px;
                    margin-right: 10px;
                }

                .bad-test {
                    color: #f56c6c;
                }
            }
        }

        .right-box {

            .right-btn {
                margin-top: 30px;
            }
        }
    }

    .el-message-box__btns {
        font-size: 16px;
        color: #333333;
    }
}
</style>